import React from 'react';

const WEEKDAY_OPTIONS = [
  { value: 'Monday', label: 'Mon' },
  { value: 'Tuesday', label: 'Tue' },
  { value: 'Wednesday', label: 'Wed' },
  { value: 'Thursday', label: 'Thu' },
  { value: 'Friday', label: 'Fri' },
  { value: 'Saturday', label: 'Sat' },
  { value: 'Sunday', label: 'Sun' },
];

const BiFilters = ({
  storeLabel,
  showStore = false,
  from,
  to,
  onFromChange,
  onToChange,
  weekdays = [],
  onWeekdaysChange,
  onRefresh,
  refreshing = false,
  inline = false,
  children,
}) => {
  const toggleWeekday = (value) => {
    if (weekdays.includes(value)) {
      onWeekdaysChange(weekdays.filter((item) => item !== value));
    } else {
      onWeekdaysChange([...weekdays, value]);
    }
  };

  const shellClass = inline
    ? 'flex flex-col items-end gap-2'
    : 'space-y-3 rounded-lg border border-slate-200 bg-white p-3 shadow-sm';

  return (
    <div className={shellClass}>
      <div className={`flex flex-wrap items-end gap-2 ${inline ? 'justify-end' : ''}`}>
        {showStore && storeLabel ? (
          <div className="flex flex-col gap-1 text-sm font-medium text-gray-600">
            Store
            <div className="rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-base font-semibold text-sky-900">
              {storeLabel}
              <span className="ml-2 text-sm font-normal text-sky-700">(from header)</span>
            </div>
          </div>
        ) : null}
        <label className="flex flex-col gap-1 text-sm font-medium text-gray-600">
          From
          <input type="date" value={from} onChange={(e) => onFromChange(e.target.value)} className="input py-1.5 text-base" />
        </label>
        <label className="flex flex-col gap-1 text-sm font-medium text-gray-600">
          To
          <input type="date" value={to} onChange={(e) => onToChange(e.target.value)} className="input py-1.5 text-base" />
        </label>
        {children}
        <button type="button" onClick={onRefresh} className="btn-secondary self-end py-1.5 text-base">
          {refreshing ? 'Refreshing…' : 'Refresh'}
        </button>
      </div>
      <div className={inline ? 'flex flex-wrap items-center justify-end gap-1.5' : ''}>
        {!inline ? (
          <p className="mb-1 text-sm font-medium text-gray-600">Weekday filter (applies to all visuals)</p>
        ) : null}
        <div className={`flex flex-wrap gap-1.5 ${inline ? 'justify-end' : ''}`}>
          {WEEKDAY_OPTIONS.map((day) => {
            const active = weekdays.includes(day.value);
            return (
              <button
                key={day.value}
                type="button"
                onClick={() => toggleWeekday(day.value)}
                className={`rounded-full px-3 py-1.5 text-sm font-semibold transition ${
                  active
                    ? 'border border-sky-200 bg-sky-50 text-sky-900'
                    : 'border border-slate-200 bg-white text-slate-600 hover:bg-slate-50'
                }`}
              >
                {day.label}
              </button>
            );
          })}
          {weekdays.length ? (
            <button
              type="button"
              onClick={() => onWeekdaysChange([])}
              className="rounded-full px-3 py-1.5 text-sm font-medium text-slate-500 underline"
            >
              Clear
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BiFilters;
export { WEEKDAY_OPTIONS };
